<div class="wrapper step-three">
    <div class="step-content">

        <div class="templates position-relative">
            <div class="arrows-left position-absolute" *ngIf="imageDescription.length > 1">
                <img
                        (click)="scroll(target, 'left')"
                        src="./assets/imgs/Arrow-slider-left.svg"
                />
            </div>
            <div class="arrows-right position-absolute" *ngIf="imageDescription.length > 1">
                <img (click)="scroll(target, 'right')" src="./assets/imgs/Arrow-slider-right.svg" />
            </div>
            <div #target class="grid">
                <div class="card" style="border-radius: 8px;height:max-content" *ngFor=" let card of imageDescription">
                    <img *ngIf="card.hasOwnProperty('imageBase64')" class="card-img-top" src="{{card.imageBase64}}" width="202px"
                         height="150px">
                    <div class="card-body" style="line-height: unset!important;">
                        <h5 *ngIf = "card.hasOwnProperty('cardName')" class="card-title" style="font-weight: 600;font-size: 14px;color:#1D2126"> {{card.cardName}} </h5>
                        <p  *ngIf = "!card.hasOwnProperty('description2')" class="card-text" style="font-size: 12px;font-weight: 400;white-space: pre-wrap;">
                            {{card.description }} </p>
                        <p  *ngIf = "card.hasOwnProperty('description2')" class="card-text" style="font-size: 12px;font-weight: 400;white-space: pre-wrap;">
                            {{card.description2}} </p>
                        <ol style="list-style-image:url('./assets/imgs/bullot.png')" *ngIf="card.hasOwnProperty('features')">
                            <li *ngFor="let feature of card.features">{{ feature }}</li>
                        </ol>
                        <a *ngIf = "card.hasOwnProperty('knowMoreLink')" href="{{card.knowMoreLink}}" class="card-link" style="text-decoration: underline;
                        font-size: 11px;color:#FF7800" target="_blank">{{card.details}}</a>
                    </div>

                    <div class="card-body" style="border-top: 2px solid #EDEEF0;padding-top: unset!important;
                    padding-left: 1.25rem; line-height: unset;padding-right: unset;
                     padding-bottom: 5px;"
                    *ngIf="card.hasOwnProperty('applyNowLink')">
                    <a href="{{card.applyNowLink}}" target="_blank">
                        <button type="button" class="btn btn-primary" style="width:90%;height: 33px;background: #FF7800;
                            border-radius: 7px;border-color: #FF7800;box-shadow:none;margin-top: 10px;margin-bottom: 10px;font-size: 10px "
                        >{{card.video}}</button></a>
                    </div>

                    <div class="card-body" style="border-top: 2px solid #EDEEF0;padding-top: unset!important;
                    padding-left: 1.25rem; line-height: unset;padding-right: unset;
                     padding-bottom: 5px;"
                    *ngIf="card.hasOwnProperty('applyNowLink2')">
                        <button type="button" class="btn btn-1" style="color: #EDEEF0 !important; width:90%;height: 33px;background: #FF7800;
                            border-radius: 7px;border-color: #FF7800;box-shadow:none;margin-top: 10px;margin-bottom: 10px;font-size: 10px "
                            (click)="sendMessage(card.text)"
                        >{{card.Buy}}</button>
                    </div>

                    <div class="card-body" style="border-top: 2px solid #EDEEF0;padding-top: unset!important;
                    padding-left: 1.25rem; line-height: unset;padding-right: unset;
                     padding-bottom: 5px;"
                    *ngIf="card.hasOwnProperty('link1') && !card.hasOwnProperty('link4')">
                    <a href="{{card.linkval1}}" target="_blank">
                        <button type="button" class="btn btn-primary" style="width:90%;height: 33px;background: #FF7800;
                            border-radius: 7px;border-color: #FF7800;box-shadow:none;margin-top: 10px;margin-bottom: 10px;font-size: 10px "
                        >{{card.link1}}</button></a>
                    </div>

                    <div class="card-body" style="border-top: 2px solid #EDEEF0;padding-top: unset!important;
                    padding-left: 1.25rem; line-height: unset;padding-right: unset;
                     padding-bottom: 5px;"
                    *ngIf="card.hasOwnProperty('link2')">
                    <a href="{{card.linkval2}}" target="_blank">
                        <button type="button" class="btn btn-primary" style="width:90%;height: 33px;background: #FF7800;
                            border-radius: 7px;border-color: #FF7800;box-shadow:none;margin-top: 10px;margin-bottom: 10px;font-size: 10px "
                        >{{card.link2}}</button></a>
                    </div>

                    <div class="card-body" style="border-top: 2px solid #EDEEF0;padding-top: unset!important;
                    padding-left: 1.25rem; line-height: unset;padding-right: unset;
                     padding-bottom: 5px;"
                    *ngIf="card.hasOwnProperty('link3')">
                    <a href="{{card.linkval3}}" target="_blank">
                        <button type="button" class="btn btn-primary" style="width:90%;height: 33px;background: #FF7800;
                            border-radius: 7px;border-color: #FF7800;box-shadow:none;margin-top: 10px;margin-bottom: 10px;font-size: 10px "
                        >{{card.link3}}</button></a>
                    </div>

                    <div class="card-body" style="border-top: 2px solid #EDEEF0;padding-top: unset!important;
                    padding-left: 1.25rem; line-height: unset;padding-right: unset;
                     padding-bottom: 5px;"
                    *ngIf="card.hasOwnProperty('link4')">
                    <a href="{{card.linkval4}}" target="_blank">
                        <button type="button" class="btn btn-primary" style="width:90%;height: 33px;background: #FF7800;
                            border-radius: 7px;border-color: #FF7800;box-shadow:none;margin-top: 10px;margin-bottom: 10px;font-size: 10px "
                        >{{card.link4}}</button></a>
                    </div>

                    <div class="card-body" style="border-top: 2px solid #EDEEF0;padding-top: unset!important;
                    padding-left: 1.25rem; line-height: unset;padding-right: unset;
                     padding-bottom: 5px;"
                    *ngIf="card.hasOwnProperty('slotValue')">
                        <button type="button" class="btn btn-primary" style="width:90%;height: 33px;background: #FF7800;
                            border-radius: 7px;border-color: #FF7800;box-shadow:none;margin-top: 10px;margin-bottom: 10px;font-size: 10px "
                            (click)="sendMessage(card.slotValue)"
                        >{{card.slotValue}}</button>
                    </div>
                </div>
                
            </div>
            <span style="font-size: 12px;float: right;padding-right: 10px;margin-top: -3rem;" *ngIf="imageDescription.length > 1">{{currentCard}}/{{imageDescription.length}}</span>
        </div>
        <!-- <button
          routerLink="/design-menu/step-three"
          class="next btn bg-gold text-white mt-5"
        >
          {{ "common.next" | translate }}
        </button> -->
    </div>
</div>
